
import ContactUs from "../../components/ContactUs";
import PlanCards from "../../components/PlanCardSection";
import SliderViewSection from "../../components/SliderViewSection";
import StayInLoop from "../../components/StayInLoop";
import TestimonialSlider from "../../components/FeedbackSlider";
import ProductLanding from "../../components/Products/ProductLanding";
import FourCardsSwap from "../../components/FourCardSwapSection";
import {  AllProductGif, Iceberg1,
 Iceberg2,
 Iceberg3,
 Iceberg4,
 Iceberg5,
 Iceberg6 } from "../../constant";



const safetyAndSustainabilityData = [
  {
    title: "ICEBERG. Connecting Every Industrial Data Source.",
    subtitle:
      "Integrate ERP, SCADA, MES, IoT devices, historians, APIs, databases, cloud platforms and industrial streams into one unified operational ecosystem.",
    lists: [
      "Pre-Built Industrial Adapters",
      "IT-OT Unified Connectivity",
      "Real-Time & Batch Ingestion",
      "Centralized data access"
    ],
    mediaUrl: Iceberg1,
  },

  {
    title: "Seamless Connectivity Across Enterprise & OT Systems.",
    subtitle:
      "Flexible adapter-based architecture enables rapid integration across legacy systems, industrial protocols and enterprise applications.",
    lists: [
      "OPC-UA, MQTT & REST Support",
      "Legacy and modern system connectivity ",
      "Configurable integration pipelines",
      "Plug-and-Play Integration",
    ],
    mediaUrl: Iceberg2,
  },

  {
    title: "Stream, Sync & Process Industrial Data in Real Time.",
    subtitle:
      "Continuously ingest and synchronize operational data from machines, sensors and enterprise systems for live operational visibility.",
    lists: [
      "Real-Time Streaming Pipelines",
      "Event-driven architecture",
      "Edge-to-Cloud Synchronization",
      "Continuous data flow management"
    ],
    mediaUrl: Iceberg3,
  },

  {
    title: "Harmonize Data Across Distributed Operations ",
    subtitle:
      "Normalize and contextualize industrial data into a standardized, analytics-ready operational intelligence layer.",
    lists: [
      "Data Harmonization",
      "Unified Industrial Schema",
      "Metadata contextualization",
      "Centralized Operational Intelligence",
    ],
    mediaUrl: Iceberg4,
  },

  {
    title: "Transform Connected Data into Actionable Insights.",
    subtitle:
      "Leverage integrated operational data for dashboards, KPI monitoring and enterprise-wide visibility across industrial operations.",
    lists: [
      "Interactive Dashboards",
      "Operational KPIs",
      "Cross-System Analytics",
      "Faster decision-making"
    ],
    mediaUrl: Iceberg5,
  },

  {
    title: "Enable AI-Ready Industrial Data Ecosystems.",
    subtitle:
      "Enable AI-ready industrial ecosystems with governed, contextualized and scalable operational data infrastructure.",
    lists: [
      "AI-Ready Contextualized Data",
      "Enterprise-Wide Interoperability",
      "Scalable industrial architecture",
      "Future-ready integration platform",
    ],
    mediaUrl: Iceberg6,
  },
];


const AuroraIntegrationPlans = [
  {
    title: "Basic",
    subtitle:
      "Essential industrial data integration capabilities for connecting foundational enterprise and operational systems.",
    features: [
      "Standard Data Connectors",
      "ERP & Database Integration",
      "File and API-Based Ingestion",
      "Centralized Data Visibility",
    ],
  },

  {
    title: "Advanced",
    subtitle:
      "Enhanced integration framework for scalable connectivity across distributed industrial and enterprise environments.",
    features: [
      "Multi-Source Data Orchestration",
      "SCADA & IoT Integration",
      "Real-Time Data Synchronization",
      "Unified Operational Data Layer",
    ],
    popular: true,
  },

  {
    title: "Premium",
    subtitle:
      "Enterprise-grade industrial data ecosystem designed for complex, high-scale IT-OT integration requirements.",
    features: [
      "Advanced Adapter Framework",
      "Enterprise-Wide Interoperability",
      "Live Streaming & Edge Integration",
      "Contextualized Industrial Intelligence",
      "Scalable and Extensible Architecture",
    ],
    recommended: true,
  },
];


const testimonialsData = [
  {
    quote:
      "NetZero enabled us to streamline ESG reporting and improve sustainability visibility across operations.",
    author: "General Manager, EHS",
    note: "An Integrated Energy Enterprise",
  },
  {
    quote:
      "The platform transformed our EHS processes with real-time monitoring, analytics, and actionable insights.",
    author: "Project Safety Head",
    note: "Major Oil & Gas Operator",
  },
  {
    quote:
      "Aurora helped us connect critical industrial assets and improve operational efficiency significantly.",
    author: "Project Manager",
    note: "An Integrated Oil & Gas Operator",
  },
  {
    quote:
      "We now manage compliance, audits, and sustainability reporting from a single intelligent platform.",
    author: "Head, Digital Transformation",
    note: "A Large Mining Company",
  },
  {
    quote:
      "Implementation was seamless, and the solution scaled perfectly across our enterprise operations.",
    author: "Chief Manager – Projects",
    note: "A Large Refining Company",
  },
  {
    quote:
      "The risk engagement simplified complex reporting requirements while improving data accuracy and governance.",
    author: "Chief Risk Officer",
    note: "A Large Power Generation Company",
  },
  {
    quote:
      "Connected operational intelligence and sustainability insights helped us achieve measurable business outcomes.",
    author: "Head – Projects",
    note: "One of the Largest EPC Players",
  },
  {
    quote:
      "Real-time visibility into risks, emissions, and compliance improved our overall operational performance.",
    author: "Head – Sustainability",
    note: "A Large Defence Manufacturer",
  },
  {
    quote:
      "A modern digital transformation platform that delivers measurable impact across EHS, ESG, and operations.",
    author: "Nodal Officer, Digital Initiatives",
    note: "One of the Largest Mining Operators",
  },
];

const FourCardsSwapcardData = [
  {
    title: "Multi-Source Data Connectivity",
    description:
      "Connect and ingest data from ERP, SCADA, MES, IoT devices, historians, databases, APIs, cloud platforms, spreadsheets, files and live industrial data streams.",
  },

  {
    title: "Adapter-Based Integration Framework",
    description:
      "Flexible adapter and connector architecture enabling seamless integration between enterprise applications, operational technologies, legacy systems and third-party platforms.",
  },

  {
    title: "Unified Industrial Data Layer",
    description:
      "Aggregate, harmonize and contextualize data from distributed IT and OT environments into a centralized industrial data ecosystem.",
  },

  {
    title: "Real-Time Data Ingestion & Synchronization",
    description:
      "Support for batch, streaming and event-driven data integration with continuous synchronization across operational and enterprise systems.",
  },

  {
    title: "Data Normalization & Contextualization",
    description:
      "Transform heterogeneous industrial data into structured, contextualized and analytics-ready information for enterprise-wide interoperability and intelligence.",
  },
];


export default function ProductIceberg() {
  return (
    <>
      <ProductLanding
        title={`Unified IT-OT Data Intelligence for Industrial Enterprises`}
        subTitle={`Enterprise Systems, SCADA & IoT Connectivity, Real-Time Data Integration. Contextualization, Harmonization & Operational Insights.`}
        isNetzero={false}
         url={AllProductGif}
      />
      <FourCardsSwap
        title={"Connect Every Industrial Data Source"}
        subTitle={"ICEBERG seamlessly integrates and harmonizes data from enterprise systems, SCADA, IoT devices, databases, APIs, files, and live industrial streams through a scalable adapter-based architecture, enabling unified data access, real-time visibility, and faster operational decision-making."}
        cardData={FourCardsSwapcardData}
      />
      <SliderViewSection
        title={"ICEBERG. Built for Connected Industrial Data."}
        subTitle={"ICEBERG accelerates industrial digital transformation by bringing together fragmented enterprise and operational data into a connected, scalable, and intelligent data ecosystem."}
        data={safetyAndSustainabilityData} />
      <TestimonialSlider testimonials={testimonialsData} />
      <PlanCards productName = {"Iceberg"} title={"Iceberg Deployment Plan"} plans={AuroraIntegrationPlans} />
      <ContactUs />
      <StayInLoop />
    </>
  );
}
